module.exports = __webpack_public_path__ + "static/media/member6.896df84a.jpg";